import { validate } from './validations';
import { build } from '../../services/crudFactory';
import { Action } from '../../services/actions.factory';
const BASE_PATH = '/lognex/notificationOccurrence';
const prefix = 'crudNotificationOccurrence';
const crud = build(validate, BASE_PATH);



const newTypes = {    
    SET_LOOKUP_OCCURENCE_TYPE_VISIBLE: `${prefix}setlookupOccurrenceTypeVisible`,
    SET_FIELD_OCCURRENCE_TYPE_FILTER: `${prefix}setFieldOccurrenceTypeFilter`,
}


const actions = new Action(prefix, crud);

const types = Object.assign({}, actions.types, newTypes);

actions.setlookupOccurrenceTypeVisible = (visible) => {
  return {
    type: types.SET_LOOKUP_OCCURENCE_TYPE_VISIBLE,
    visible,
  };
};
actions.setFieldOccurrenceTypeFilter = (fieldName, fieldValue) => {
  return {
    type: types.SET_FIELD_OCCURRENCE_TYPE_FILTER,
    fieldName,
    fieldValue,
  };
};

export { types, actions }

